// @flow
import * as React from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/dropdown.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/transition.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import type { modelEnum } from './models'
import model from './models'
import './styles.scss'
import config from 'config'
import Dropdown from './dropdownContainer'

export type selectorProps = {
  currentModel: modelEnum,
  currentIncome: number,
  currentYear: number,
  availableIncomeBrackets: number[],
  modelChangeHandler: modelEnum => void,
  incomeChangeHandler: number => void,
  yearChangeHandler: number => void
}

const models = [
  model.SINGLE,
  model.RETIRED,
  model.MARRIED_WITHOUT_CHILDREN,
  model.MARRIED_WITH_CHILDREN,
  model.MARRIED_WITH_CHILDREN_AND_DUAL_INCOME
]

export default function Selector ({
  currentModel,
  modelChangeHandler,
  currentIncome,
  incomeChangeHandler,
  currentYear,
  yearChangeHandler,
  availableIncomeBrackets
}: selectorProps) {
  return (
    <div className='selector ui form'>
      <div className='stackable two fields'>
        <div className='field'>
          <label>Choisissez le modèle de calcul&thinsp;…</label>
          <Dropdown
            currentValue={currentModel}
            currentText={currentModel}
            changeHandler={modelChangeHandler}
            options={models.map(model => ({ text: model, value: model }))}
          />
        </div>
        <div className='field'>
          <label>…&thinsp;et le revenu annuel brut en CHF</label>
          <Dropdown
            currentText={config.formatAsIntegerCurrency(currentIncome)}
            currentValue={currentIncome}
            options={availableIncomeBrackets.map(bracket => ({
              text: config.formatAsIntegerCurrency(bracket),
              value: bracket
            }))}
            changeHandler={incomeChangeHandler}
          />
        </div>
      </div>
    </div>
  )
}

// function ModelItem ({
//                      model,
//                      currentModel,
//                      handler
//                    }): Element<any> {
//  return <a onClick={handler.bind(null, model)}
//    className={`item ${currentModel ===
//            model
//              ? 'active'
//              : ''}`}>{model}</a>
// }



// WEBPACK FOOTER //
// ./src/components/selector/selectorComponent.js